export default __webpack_public_path__ + "static/media/1694.bc365353.png";